// filepath: apps/web/src/features/observability/ObservabilityDashboardRoute.tsx
//
// FR-UI-DASH-1 -- route shell for the tenant observability dashboard.
//
// URL: /observability/dashboard
//
// The route enforces the AuthGuard at the SPA layer (defense-in-
// depth; the server's `requireAuth` middleware covers authentication).
// No environmentKind gate -- the observability dashboard is
// all-environments per ARCHITECTURE_WEB.md §10 (the FR-OBS-1
// trace endpoints serve both staging and production).
//
// Mirrors the FR-UI-PROC-1 `ProcRoute` pattern (in-process pathname
// dispatcher; reads `window.location.pathname`; no react-router
// dependency -- App.tsx convention). The route is registered in
// App.tsx's AuthStateRouter block.

import React from "react";
import { ObservabilityDashboardPage } from "./ObservabilityDashboardPage";

const OBSERVABILITY_DASHBOARD_PATH_RE = /^\/observability\/dashboard\/?$/;

export function ObservabilityDashboardRoute(): React.ReactElement | null {
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "/";

  if (!OBSERVABILITY_DASHBOARD_PATH_RE.test(pathname)) {
    return (
      <main data-testid="observability-route-no-match">
        <p>Unknown observability route.</p>
      </main>
    );
  }

  return <ObservabilityDashboardPage />;
}
